import { flatMapDeep, cloneDeep, filter } from 'lodash';

/* eslint-disable */
export const filterTree = (tree, target) => {
  if (tree.value === target) {
    return tree;
  }
  for (const child of tree.children) {
    const res = filterTree(child, target);
    if (res) {
      return res;
    }
  }
};

const fetchLeaves = (node, leaves) => {
  leaves = leaves || [];
  if (node.leaf) {
    leaves.push(node);
  } else {
    for (const child of node.children) {
      fetchLeaves(child, leaves);
    }
  }
  return leaves;
};

/* eslint-enable */

export const updateTree = (tree, updates, mode) => {
  tree.forEach((node) => {
    if (node.value === updates.value) {
      node.checked = updates.checked;
      if (node.children.length > 0 && ['selectAll', 'leavesOnly'].includes(mode)) {
        commitChildren(node, updates.checked);
      }
    } else if (node && node.children && node.children.length > 0) {
      updateTree(node.children, updates, mode);
    }
  });
  return tree;
};

export const recursiveUpdateTree = (entityIds, currentTree = {}, index = 0) => {
  if (index >= entityIds.length) {
    return currentTree;
  }
  const newTree = updateTree(cloneDeep(currentTree), { checked: true, value: entityIds[index] }, 'singleNode');

  return recursiveUpdateTree(entityIds, newTree, index + 1);
};

export const getSubTreeByParentId = (tree, targetId) =>
  tree.reduce((found, node) => {
    // Si on l'a déjà trouvé dans une itération précédente, on conserve le résultat
    if (found) return found;

    // Si c'est le bon nœud, on le retourne
    if (node.value === targetId) return node;

    // Sinon, si le nœud a des enfants, on cherche dedans
    if (node.children?.length) {
      return getSubTreeByParentId(node.children, targetId);
    }

    return null;
  }, null);

const commitChildren = (parent, check) => {
  if (parent.children.length > 0) {
    parent.children.forEach((child) => {
      child.checked = check;
      commitChildren(child, check);
    });
  }
};

const getNodes = (node) => {
  const cleanNode = { value: node.value, label: node.label, checked: node.checked, leaf: node.leaf };

  if (!node.children || !node.children.length) {
    return cleanNode;
  }
  return [cleanNode, flatMapDeep(node.children, getNodes)];
};

export const filterCheckedLeaves = (tree) => filter(flatMapDeep(tree, getNodes), { checked: true, leaf: true });
export const filterCheckedAllNodes = (tree) => filter(flatMapDeep(tree, getNodes), { checked: true });
